module.exports = __webpack_public_path__ + "img/TACOS.5599e0d4.png";